// extracted by mini-css-extract-plugin
export default {"video-js":"plugin__video-js--2ZGqC","vjs-hls-quality-selector":"plugin__vjs-hls-quality-selector--1C0-7"};